import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { templateLanguageDisplayName, templateLanguageShortName } from "../template-picker.js";

export function templateCategoryLabel(t: (key: string) => string, category: string): string {
  switch (category.trim().toUpperCase()) {
    case "UTILITY":
      return t("inbox.templateSend.categories.UTILITY");
    case "MARKETING":
      return t("inbox.templateSend.categories.MARKETING");
    default:
      return category;
  }
}

/** Category pill + language label shown on list items and the detail heading. */
export function TemplateMetaBadges({
  category,
  language,
  compactLanguage = false,
}: {
  category: string;
  language: string;
  /** Base language only, for narrow list rows. */
  compactLanguage?: boolean;
}): React.JSX.Element {
  const { t, i18n } = useTranslation();
  const marketing = category.trim().toUpperCase() === "MARKETING";
  const languageLabel = compactLanguage
    ? templateLanguageShortName(language, i18n.language)
    : templateLanguageDisplayName(language, i18n.language);
  return (
    <>
      <span
        className={cn(
          "shrink-0 rounded-full px-1.5 text-[0.625rem] font-semibold leading-4",
          marketing ? "bg-[#fdf0e3] text-[#8a4b12]" : "bg-inbox-pill text-[#4f625d]",
        )}
      >
        {templateCategoryLabel(t, category)}
      </span>
      <span className="shrink-0 text-[0.625rem] font-semibold text-inbox-subtle">
        {languageLabel}
      </span>
    </>
  );
}
